import React, { Component } from 'react';
import axios from 'axios'


class CollectionButtonDelete extends Component {
  constructor(props) {
      super(props);
      this.state = {
        clickToConfirm: false
      }
  }
  componentDidMount(){
    axios.defaults.headers.common['token'] = localStorage.getItem('token');
  }
  _handleButton = (e,type) => {
    if (type === 'buttonDelete'){
      this.setState({clickToConfirm: true})
    } else if (type === 'confirmDelete') {
      this.deleteCollection();
    }
  }
  deleteCollection(){
    this.props.updateData('DELETE_CATEGORY');
    // const url = Generals.DOMAIN_NAME_API + '/fabrics/'+this.props.fabricID;
    //   axios.delete(url)
    //   .then(
    //     res=>{
    //       this.props.updateData();
    //     }
    //   )
  }
  render() {
    const interfaceLocale = this.props.locale;
    return this.state.clickToConfirm ?
    <button type="submit" className="btn btn-outline-secondary form-button" onClick={(e)=>{ this._handleButton(e,"confirmDelete") }}>{interfaceLocale['collection']['buttonConfirm']}</button> :
    <button type="submit" className="btn btn-outline-secondary form-button" onClick={(e)=>{ this._handleButton(e,"buttonDelete") }}>{interfaceLocale['collection']['buttonDelete']}</button>
  }
}

export default CollectionButtonDelete;
